import React from "react";
import { CodeBlock } from "react-code-block";
import { useCopyToClipboard } from "react-use";
import "@fortawesome/fontawesome-svg-core/styles.css";
import YouTube from "react-youtube";

function LegoL99ADataComponent({ code, language }) {
  code = `// Data-driven L99A: renders icon/logo + description cards from an array.
// Component: components/legosRefactored-24/dataDriven/LegoL99AData.js

import LegoL99AData from "../legosRefactored-24/dataDriven/LegoL99AData";

// WEBSITE cards: include linkText -> logo + linked title + description
const websites = [
  {
    title: "Plant-Based Mavens",
    href: "https://www.plantbasedmavens.com",
    linkText: "www.plantbasedmavens.com",
    img: "<LOGO_URL>",
    description: "Plant-based nutrition for women",
  },
];

// APP cards: omit linkText -> bold title + "Click image or this link to view."
const apps = [
  {
    title: "Bitesnap",
    href: "https://getbitesnap.com/",
    img: "<ICON_URL>",
    description: "Keep a photo diary of your meals...",
  },
];

<LegoL99AData cards={websites} />
<LegoL99AData cards={apps} />`;
  language = "jsx";
  const [state, copyToClipboard] = useCopyToClipboard();

  const copyCode = () => {
    copyToClipboard(code);
  };

  return (
    <CodeBlock code={code} language={language}>
      <div className="relative">
        <CodeBlock.Code className="bg-black">
          <div className="table-row">
            <CodeBlock.LineNumber className="table-cell pr-4 text-sm text-gray-500 text-right select-none" />
            <CodeBlock.LineContent className="table-cell">
              <CodeBlock.Token />
            </CodeBlock.LineContent>
          </div>
        </CodeBlock.Code>
        <div className="buttonContainer">
          <button className="btn btn-primary ml-auto" onClick={copyCode}>
            <i className="fa-solid fa-copy"></i>{" "}
            {state.value ? "Copied!" : "Copy code"}
          </button>
        </div>
      </div>
    </CodeBlock>
  );
}

export default LegoL99ADataComponent;
